import { render } from "./noBorder.vue?vue&type=template&id=5ba496f0"
import script from "./noBorder.vue?vue&type=script&lang=js"
export * from "./noBorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__